/* kit-global.js — shared helpers for kit- sections. Exposes window.Kit. */
(function () {
  if (window.Kit) return;

  const cfg = window.kitConfig || {};

  function formatMoney(cents, format) {
    const fmt = format || cfg.moneyFormat || '${{amount}}';
    const value = Number(cents || 0);
    const withDelims = (n, decimals, thousands, decimal) => {
      const fixed = (n / 100).toFixed(decimals);
      const [int, dec] = fixed.split('.');
      const intStr = int.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return dec ? intStr + decimal + dec : intStr;
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount_no_decimals': return withDelims(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withDelims(value, 2, "'", '.');
        default: return withDelims(value, 2, ',', '.');
      }
    });
  }

  /* ---------- Toast ---------- */
  let toastTimer;
  function toast(message, link) {
    let el = document.getElementById('KitToast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'KitToast';
      el.className = 'kit-toast';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    el.textContent = message;
    if (link) {
      const a = document.createElement('a');
      a.href = link.href;
      a.textContent = link.label;
      el.appendChild(a);
    }
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('is-visible'), link ? 4000 : 2200);
  }

  /* ---------- Panels (menu drawer, cart drawer) ---------- */
  let lastFocus = null;
  function openPanel(id) {
    const panel = document.getElementById(id);
    if (!panel) return;
    const overlay = document.querySelector(`[data-kit-overlay="${id}"]`);
    lastFocus = document.activeElement;
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.classList.add('is-open');
    document.documentElement.classList.add('kit-lock');
    const focusable = panel.querySelector('[data-kit-autofocus], button, a, input');
    if (focusable) setTimeout(() => focusable.focus({ preventScroll: true }), 50);
    document.dispatchEvent(new CustomEvent('kit:panel:open', { detail: { id } }));
  }
  function closePanel(id) {
    const panel = document.getElementById(id);
    if (!panel || !panel.classList.contains('is-open')) return;
    const overlay = document.querySelector(`[data-kit-overlay="${id}"]`);
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    if (overlay) overlay.classList.remove('is-open');
    if (!document.querySelector('.kit-panel.is-open')) document.documentElement.classList.remove('kit-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-kit-open]');
    if (opener) {
      e.preventDefault();
      openPanel(opener.getAttribute('data-kit-open'));
      return;
    }
    const closer = e.target.closest('[data-kit-close]');
    if (closer) {
      e.preventDefault();
      closePanel(closer.getAttribute('data-kit-close'));
      return;
    }
    const overlay = e.target.closest('[data-kit-overlay]');
    if (overlay) closePanel(overlay.getAttribute('data-kit-overlay'));
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.kit-panel.is-open').forEach((p) => closePanel(p.id));
  });

  /* ---------- Cart ---------- */
  const root = (cfg.routes && cfg.routes.root) || '/';

  async function fetchJSON(url, opts) {
    const res = await fetch(url, Object.assign({ headers: { 'Content-Type': 'application/json', Accept: 'application/json' } }, opts));
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
      const err = new Error(data.description || data.message || 'Cart error');
      err.data = data;
      throw err;
    }
    return data;
  }

  function setCartCount(count) {
    document.querySelectorAll('[data-kit-cart-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = !count;
    });
  }

  async function refreshCount() {
    const cart = await fetchJSON(root + 'cart.js');
    setCartCount(cart.item_count);
    return cart;
  }

  /**
   * Add several lines at once. items: [{ id, quantity, properties? }]
   * Returns the updated cart.
   */
  async function addItems(items) {
    await fetchJSON(root + 'cart/add.js', { method: 'POST', body: JSON.stringify({ items }) });
    const cart = await refreshCount();
    document.dispatchEvent(new CustomEvent('kit:cart:updated', { detail: { cart, source: 'add' } }));
    return cart;
  }

  /** Called after a successful add from a product form. */
  function afterAdd() {
    if (window.KitCart && typeof window.KitCart.open === 'function') {
      window.KitCart.open();
      return;
    }
    toast(cfg.strings?.added || 'Added to cart', { href: (cfg.routes && cfg.routes.cart) || '/cart', label: cfg.strings?.viewCart || 'View cart' });
  }

  window.Kit = { formatMoney, toast, openPanel, closePanel, fetchJSON, addItems, refreshCount, setCartCount, afterAdd };
})();
